const scrollHeader = () => {
    const siteHeaderElem = document.querySelector('.js-site-header');
    const operationType = window.scrollY > 50 ? 'add' : 'remove';
    siteHeaderElem && siteHeaderElem.classList[operationType]('scrolled');
};
export default scrollHeader;
